import { GameEntryAttrs } from "@locent/types";

import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** 游戏入口组件类 */
export class GameEntryComponent extends BaseComponent<
  GameEntryAttrs & {
    [key: string]: string | number | boolean | object | null | undefined;
  }
> {
  constructor(
    data: Partial<
      BaseComponent<
        GameEntryAttrs & {
          [key: string]: string | number | boolean | object | null | undefined;
        }
      >
    > = {},
  ) {
    super(data);
    this.type = CompType.game_entry;
  }

  /** 获取标题文本 */
  public getTitleText(): string {
    return this.title;
  }

  /** 获取入口列表 */
  public getEntryList() {
    return this.attrs?.entry_list;
    //! Todo: api params
    // return this.lang_attrs?.list || [];
  }

  // /** 获取指定链接 */
  // public getSpecifyLink(type: string): string {
  //   let link: string = "";
  //   switch (type) {
  //     case GameEntryEnum.casino:
  //       link = this.attrs.casino_link;
  //       break;
  //     case GameEntryEnum.sport:
  //       link = this.attrs.sport_link;
  //       break;
  //     case GameEntryEnum.lottery:
  //       link = this.attrs.lottery_link;
  //       break;
  //     case GameEntryEnum.live:
  //       link = this.attrs.live_link;
  //       break;
  //     case GameEntryEnum.bingo:
  //       link = this.attrs.bingo_link;
  //       break;
  //     default:
  //       break;
  //   }
  //   return link;
  // }
}
export type EntryList = {
  name: string;
  title: string;
  content: string;
  button: string;
  sort: number;
};
// // 使用示例
// const gameEntryData: Partial<BaseComponent<GameEntryAttrs>> = {
//   id: "66fff0f860238e371f584ac7",
//   type: CompType.game_entry,
//   variant: "",
//   title: "游戏大类ZH",
//   status: 1,
//   sort: 0,
//   login_type: LoginType.Login,
//   recharge_type: RechargeType.Recharge,
//   fixed_top: 0,
//   key: "game_entry_1728049398",
//   show_rtp: false,
//   height: "",
//   attrs: {
//     casino_link: "/casino",
//     sport_link: "/sport",
//     lottery_link: "/lottery",
//     live_link: "/live",
//     bingo_link: "/casino/Special",
//     title_text: {
//       "1": "游戏大类EN",
//       "4": "游戏大类ZH",
//       "11": "游戏大类PT",
//       "12": "游戏大类XY",
//     },
//     title_icon: "fire",
//     entry_list: ["casino", "sport", "live"],
//   },
// };
